module.exports = __webpack_public_path__ + "img/orchidmantis.bd062094.png";